import { Injectable } from '@angular/core';
import {
  BodyOutputType,
  OnActionCallback,
  Toast,
  ToasterService as ToastService,
  ToastType,
} from 'angular2-toaster';
import { noop } from 'lodash';
import { TOASTER_TIMEOUT } from './toaster.data';

@Injectable()
export class ToasterService {
  constructor(private _toastService: ToastService) {}

  notify(
    type: string,
    component: any,
    toastContainerId: number,
    onShowCallback: OnActionCallback = noop,
    onHideCallback: OnActionCallback = noop
  ) {
    const toast: Toast = {
      type: type as ToastType,
      body: component,
      bodyOutputType: BodyOutputType.Component,
      toastContainerId,
      timeout: TOASTER_TIMEOUT,
      showCloseButton: false,
      onShowCallback,
      onHideCallback,
    };

    return this._toastService.pop(toast);
  }

  clear(toastId: string, toastContainerId: number) {
    this._toastService.clear(toastId, toastContainerId);
  }
}
